import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
export function HourglassIllustration() {
  return _jsxs("svg", {
    width: "160",
    height: "160",
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [_jsx("path", {
      d: "M131.299 39.8189C155.631 67.886 154.19 107.988 126.295 132.17C98.3995 156.353 49.6073 143.797 25.2755 115.73C0.943793 87.6626 11.6724 48.2243 36.2013 28.2464C62.3888 6.91765 106.967 11.7519 131.299 39.8189Z",
      fill: "#E6EFFF"
    }), _jsx("path", {
      d: "M34.8672 15.7031C39.3229 44.8426 51.2925 58.9113 68.6404 74.5248C70.5816 76.272 71.7106 78.7546 71.7106 81.3662C71.7106 83.9779 70.5816 86.4605 68.6404 88.2076C51.2925 103.821 39.3229 117.89 34.8672 147.029H120.118C115.662 117.89 103.693 103.821 86.3447 88.2076C84.4035 86.4604 83.2745 83.9779 83.2745 81.3662C83.2745 78.7546 84.4037 76.2721 86.3441 74.5241C103.675 58.9109 115.495 44.8422 119.95 15.7031H34.8672Z",
      fill: "white"
    }), _jsx("path", {
      d: "M83.2734 77.2585C102.279 60.4915 115.235 46.5315 119.949 15.7031M120.117 147.029C117.692 131.174 113.044 119.781 106.514 110.173",
      stroke: "#9DC3FF",
      strokeWidth: "2.94106",
      strokeLinecap: "round"
    }), _jsx("path", {
      d: "M67.2551 96.7383C63.2504 99.6755 60.0154 103.519 57.0098 107.343",
      stroke: "white",
      strokeWidth: "4.22805",
      strokeLinecap: "round"
    }), _jsx("path", {
      d: "M48.2734 41.6367C45.2422 36.1093 41.7155 27.5605 40.2891 21.4981",
      stroke: "white",
      strokeWidth: "4.22805",
      strokeLinecap: "round"
    }), _jsx("path", {
      d: "M44.5664 22.9668C50.014 40.8583 57.473 49.8719 69.8239 64.279C71.7416 66.5161 74.5454 67.8078 77.4919 67.8078C80.4384 67.8078 83.2423 66.5161 85.16 64.279C97.5109 49.8719 104.97 40.8583 110.417 22.9668H44.5664Z",
      fill: "#FFCC60"
    }), _jsx("path", {
      d: "M71.2929 118.941L59.3763 122.762C54.4774 124.333 50.2547 127.662 48.217 132.385C46.5131 136.336 44.9938 140.707 43.6049 145.768L111.375 145.768C109.986 140.707 108.467 136.336 106.763 132.385C104.725 127.662 100.502 124.333 95.6036 122.762L83.687 118.941C79.6567 117.648 75.3232 117.648 71.2929 118.941Z",
      fill: "#FFCC60"
    }), _jsx("path", {
      d: "M77.6621 63.916V85.6401",
      stroke: "#FFCC60",
      strokeWidth: "5.07366",
      strokeLinecap: "round"
    }), _jsx("path", {
      d: "M77.6621 94.0723V99.4037",
      stroke: "#FFCC60",
      strokeWidth: "5.07366",
      strokeLinecap: "round"
    }), _jsx("path", {
      d: "M31.9863 15.1172H122.999",
      stroke: "#002661",
      strokeWidth: "6.76488",
      strokeLinecap: "round"
    }), _jsx("path", {
      d: "M31.9863 147.029H122.999",
      stroke: "#002661",
      strokeWidth: "6.76488",
      strokeLinecap: "round"
    }), _jsx("circle", {
      cx: "93.0247",
      cy: "129.634",
      r: "2.23368",
      fill: "#FFF5DF"
    }), _jsx("circle", {
      cx: "88.1204",
      cy: "136.935",
      r: "2.23368",
      fill: "#FFF5DF"
    }), _jsx("circle", {
      cx: "98.1165",
      cy: "136.935",
      r: "2.23368",
      fill: "#FFF5DF"
    }), _jsx("circle", {
      cx: "90.6946",
      cy: "28.804",
      r: "2.23368",
      fill: "#FFF5DF"
    }), _jsx("circle", {
      cx: "85.7903",
      cy: "36.1048",
      r: "2.23368",
      fill: "#FFF5DF"
    }), _jsx("circle", {
      cx: "95.7845",
      cy: "36.1048",
      r: "2.23368",
      fill: "#FFF5DF"
    })]
  });
}